import { RedirectErrorData } from "../types/error.type";
import {
  REDIRECT_ERROR_CODE,
  SESSION_EXPIRED_ERROR_CODE,
  UNAUTHORIZED_ACCESS_ERROR_CODE,
} from "../utils/error.utils";

const ERROR_TO_REDIRECT = [
  REDIRECT_ERROR_CODE,
  SESSION_EXPIRED_ERROR_CODE,
  UNAUTHORIZED_ACCESS_ERROR_CODE,
];

const searchParamsToKeyValuePairs = (searchParams: URLSearchParams) => {
  const params: Record<string, unknown> = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

export const checkForcedRedirect = (
  statusCode?: number,
  locationUrl?: string | null | undefined,
): RedirectErrorData | undefined => {
  if (statusCode && ERROR_TO_REDIRECT.includes(statusCode)) {
    if (locationUrl) {
      try {
        const url = new URL(locationUrl);

        const reload = !!url.searchParams.get("reload");
        url.searchParams.delete("reload");
        const urlSearchParamObject: Record<string, unknown> =
          searchParamsToKeyValuePairs(url.searchParams);

        const origin = reload ? url.origin : window.location.origin;
        const originSearchURL = new URL(window.location.href);
        const originalSearchParamObject: Record<string, unknown> =
          searchParamsToKeyValuePairs(originSearchURL.searchParams);

        const allSearchParams = {
          ...originalSearchParamObject,
          ...urlSearchParamObject,
        };
        const { pathname } = url;

        const allSearchParamsAsString = Object.keys(allSearchParams)
          .map(key => `${key}=${allSearchParams[key]}`)
          .join("&");
        const search = allSearchParamsAsString
          ? `?${allSearchParamsAsString}`
          : "";
        return {
          origin,
          reload,
          pathname,
          search,
          fullPath: `${origin}${pathname}${search}`,
        };
      } catch (e) {
        console.log("Error creating redirect link", e);
      }
    }
  }
};
